export const Functions = {
  create: true,
  delete: true,
  detail: true,
  search: false,
};

export const PageName = '公益项目分类列表';
